<button
  type="button"
  class="bz-menu__trigger"
  [matMenuTriggerFor]="menu"
  [attr.aria-label]="ariaLabel() || null"
>
  <ng-content />
</button>

<mat-menu #menu="matMenu">
  @for (item of items(); track item.id) {
    @if (item.dividerBefore) {
      <hr class="bz-menu__divider" aria-hidden="true" />
    }
    <button mat-menu-item type="button" [disabled]="!!item.disabled" (click)="selected.emit(item)">
      {{ item.label }}
    </button>
  }
</mat-menu>
